import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://codeviora.com';
const SITE_NAME = 'CodeViora';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function SEO({ title, description, canonical, ogType = 'website', ogImage = DEFAULT_IMAGE, twitterCard = 'summary_large_image', noIndex = false }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Web Development, Design & Digital Marketing`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={`${SITE_URL}${canonical}`} />}
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      {canonical && <meta property="og:url" content={`${SITE_URL}${canonical}`} />}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:site" content="@codeviora" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
